import React, { Fragment, useEffect, useState } from 'react';
import logo from '../../styles/images/logoText.svg';
import { useClearCache } from '../../utils/customHooks/useClearCache';
import './splash.scss';

const Splash = (props) => {
    const [showOneSecond, setShowOneSecond] = useState(true);
    const [clearCache] = useClearCache();

    useEffect(() => {
        setTimeout(() => {
            setShowOneSecond(false);
        }, 1000);

    }, []);

    return (
        <Fragment>
            {(showOneSecond) && (
                <div className='splash-wrapper'>
                    <img src={logo} alt={'logo'} />
                </div>
            )}
            {props.children}
        </Fragment>
    )
}

export default Splash;